<template>
    <program-sponsors-list routeName="employee-trainee-sponsor-details"></program-sponsors-list>
</template>

<script>
import ProgramSponsorsList from '@/views/Employee/ProgramComponents/ProgramDetails/ProgramSponsors/ProgramSponsorsList.vue'

export default {
    name: "TraineeSponsorList",
    components: {ProgramSponsorsList  },
    data: () => ({})
}
</script>